import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Home,
  Palette,
  Users,
  Award,
  Briefcase,
  FlaskConical,
  Beaker,
  LogOut,
  Link2,
  BookOpen,
  Images,
  Menu,
  ContactRound,
  Inbox,
  MessageSquareWarning,
  Calculator,
  BarChart3,
  GraduationCap,
  Shield,
} from "lucide-react";
import { useCmsAuth } from "../context/CmsAuthContext";

const NAV = [
  { to: "/admin", end: true, label: "Resumen", icon: LayoutDashboard, module: "dashboard" },
  { to: "/admin/home", label: "Home", icon: Home, module: "home" },
  { to: "/admin/clientes", label: "Clientes", icon: ContactRound, module: "clientes" },
  { to: "/admin/leads", label: "Consultas / cotiz.", icon: Inbox, module: "leads" },
  {
    to: "/admin/quejas",
    label: "Quejas / sugerencias",
    icon: MessageSquareWarning,
    module: "quejas",
  },
  { to: "/admin/footer", label: "Footer", icon: Link2, module: "footer" },
  { to: "/admin/navigation", label: "Menú responsivo", icon: Menu, module: "navigation" },
  { to: "/admin/about", label: "Nosotros", icon: BookOpen, module: "about" },
  { to: "/admin/credibility", label: "Credibilidad", icon: Award, module: "credibility" },
  { to: "/admin/services", label: "Servicios", icon: Briefcase, module: "services" },
  { to: "/admin/research", label: "Investigación", icon: FlaskConical, module: "research" },
  { to: "/admin/labsyso", label: "LABSYSO", icon: Beaker, module: "labsyso" },
  { to: "/admin/identidad", label: "Identidad", icon: Palette, module: "identidad" },
  { to: "/admin/icons", label: "Iconos", icon: Images, module: "icons" },
  { to: "/admin/calculadoras", label: "Calculadoras", icon: Calculator, module: "calculadoras" },
  { to: "/admin/privacidad", label: "Privacidad", icon: Shield, module: "privacidad" },
  { to: "/admin/informes", label: "Informes", icon: BarChart3, module: "informes" },
  { to: "/admin/users", label: "Usuarios", icon: Users, module: "users" },
  { to: "/admin/biblioteca/usuario", label: "Tutorial", icon: GraduationCap, module: null },
];

export default function CmsLayout() {
  const { profile, logout, user, hasModule } = useCmsAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = NAV.filter((item) => !item.module || hasModule(item.module));

  const onLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#f3f6f2] text-brand-dark flex">
      <aside className="w-64 shrink-0 bg-[#050e08] text-white hidden md:flex flex-col">
        <div className="p-6 border-b border-white/10">
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-brand-accent">
            AGDYSA CMS
          </p>
          <h1 className="font-display font-black text-xl mt-1">Mantenimiento</h1>
          <p className="text-xs text-white/50 mt-2 truncate">{user?.email}</p>
          <p className="text-[10px] uppercase tracking-widest text-brand-accent mt-1">
            {profile?.role || "editor"}
          </p>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {navItems.map(({ to, end, label, icon: Icon, module }) => (
            <NavLink
              key={to}
              to={to}
              end={end ?? (module == null && to.includes("/biblioteca") ? false : end)}
              className={({ isActive }) => {
                const active =
                  isActive ||
                  (to.includes("/biblioteca") && location.pathname.startsWith("/admin/biblioteca"));
                return `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors ${
                  active
                    ? "bg-brand-accent text-brand-dark"
                    : "text-white/70 hover:bg-white/5 hover:text-white"
                }`;
              }}
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <button
          type="button"
          onClick={onLogout}
          className="m-4 flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-bold text-white/70 hover:bg-white/5"
        >
          <LogOut size={16} />
          Cerrar sesión
        </button>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="md:hidden bg-[#050e08] text-white px-4 py-3 flex items-center justify-between">
          <span className="font-bold text-sm">AGDYSA CMS</span>
          <button type="button" onClick={onLogout} className="text-xs font-bold uppercase tracking-widest">
            Salir
          </button>
        </header>
        <main className="flex-1 p-4 md:p-8 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
